"use strict";

export function decodeJwtPayload(token) {
  try {
    const payload = String(token || "").split(".")[1];
    if (!payload) return null;
    const normalized = payload.replace(/-/g, "+").replace(/_/g, "/");
    const padded = normalized.padEnd(normalized.length + ((4 - (normalized.length % 4)) % 4), "=");
    return JSON.parse(window.atob(padded));
  } catch (_err) {
    return null;
  }
}

export function isJwtExpired(token, nowMs = Date.now()) {
  const payload = decodeJwtPayload(token);
  const expSeconds = Number(payload?.exp || 0);
  if (!expSeconds) return true;
  return nowMs >= expSeconds * 1000;
}

export function clearStoredAuth() {
  localStorage.removeItem("token");
  localStorage.removeItem("userid");
  localStorage.removeItem("role");
}
